export const PageModel = {
  GOVERNMENT_ID: 10,
  PAYMENT_METHOD: 12,
  PAYMENT_METHOD_FORM_SPEC: 13,
  APPLICATION_SIGN: 20,
  APPLICATION_INSPECTION: 22,
  APPLICATION_REJECTED: 23,
  APPLICATION_DONE: 24,
  APPLICATION_SUPPLEMENTING_REQUIRED: 25,
  PAYMENT_SIGN: 30,
  PAYMENT_IDENTIFICATION: 31,
  PAYMENT_INSPECTION: 32,
  PAYMENT_REJECTED: 33,
  PAYMENT_DONE: 35,
  ERROR: 40,
  PAYMENT_ADJUST_PURCHASE_AMOUNT: 50,
  SIGNING_REQUEST_SENT: 60,
  APPLICATION_PUSHED_OUT_TO_CUSTOMER: 61,
  PAYMENT_PUSHED_OUT_TO_CUSTOMER: 62,
}

export const StepModel = {
  GOVERNMENT_ID: 0,
  SELECT_PAYMENT_METHOD: 1,
  SIGN_IDENTIFY: 2,
  DONE: 3,
}

export const PathModel = {
  [PageModel.GOVERNMENT_ID]: '/apply',
  [PageModel.PAYMENT_METHOD]: '/apply/payment_method',
  [PageModel.PAYMENT_METHOD_FORM_SPEC]: '/apply/form_spec',
  [PageModel.APPLICATION_SIGN]: '/apply/application_sign',
  [PageModel.APPLICATION_INSPECTION]: '/apply/application_inspection',
  [PageModel.APPLICATION_REJECTED]: '/apply/application_rejected',
  [PageModel.APPLICATION_PUSHED_OUT_TO_CUSTOMER]:
    '/apply/application_pushed_out',
  [PageModel.PAYMENT_PUSHED_OUT_TO_CUSTOMER]: '/apply/payment_pushed_out',
  [PageModel.APPLICATION_DONE]: '/apply/application_done',
  [PageModel.APPLICATION_SUPPLEMENTING_REQUIRED]:
    '/apply/supplementing_required',
  [PageModel.PAYMENT_SIGN]: '/apply/payment_sign',
  [PageModel.SIGNING_REQUEST_SENT]: '/apply/signing_request_sent',
  [PageModel.PAYMENT_IDENTIFICATION]: '/apply/payment_identification',
  [PageModel.PAYMENT_INSPECTION]: '/apply/payment_inspection',
  [PageModel.PAYMENT_REJECTED]: '/apply/payment_rejected',
  [PageModel.PAYMENT_DONE]: '/apply/payment_done',
  [PageModel.PAYMENT_ADJUST_PURCHASE_AMOUNT]: '/apply/payment_amount',
  [PageModel.ERROR]: '/apply/error',
}

export const CustomerTypeModel = {
  NATURAL: 'NATURAL',
  LEGAL: 'LEGAL',
}

export const pageByPath = path => {
  return (
    +Object.keys(PathModel).filter(k => PathModel[k] === path)[0] ||
    PageModel.ERROR
  )
}

export const isPath = (currentPage, path) => {
  return PathModel[currentPage] === path
}
